import { combineReducers } from 'redux';
import storage from './storage';
import fetched from './fetched';

export default combineReducers({
  fetched,
  storage,
});
